import React, { useEffect, useState } from "react";
import { Card, Alert, AlertTitle, CircularProgress, Box } from "@mui/material";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const styles = {
  rootCard: {
    maxWidth: 345
  },
  root: (theme) => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  }),
  media: (theme) => ({
    height: 140
    , padding: theme.spacing(6, 2)
  })
};
function Employee() {
  const navigate = useNavigate();
  const [roleTypes, setRoleTypes] = useState(0);
  const [loading, setLoading] = useState(true);
  const SessionUser = getUser();
  useEffect(() => {
    getEmployeeManagementRole();

  }, []);

  const getEmployeeManagementRole = () => {
    setLoading(true);
    axios.get(`GetEmployeeManagementRole`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setRoleTypes(response.data[0]);
        } else {
          setRoleTypes(0);
        }
        setLoading(false);
      });

  }




  if (loading) {
    return (
      <Page sx={styles.root} title={"Çalışan Yönetimi"}>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <CircularProgress />
        </Box>
      </Page>
    );
  }

  return (
    <Page
      sx={styles.root}
      title={"Çalışan Yönetimi"}
    >
      <Grid container>
        <Grid
          xm={12}
          size={{
            xs: 12,
            xl: 12
          }}>
          <Grid container spacing={2} justifyContent="center">
            {roleTypes.SERVIS_GOREBILIR ?
              <Grid
                key={1}
                xm={12}
                component={RouterLink}
                to={`/EmployeeMain/1`}
                style={{ display: "flex", justifyContent: "center" }}
                size={{
                  xs: 12,
                  sm: 6
                }}>
                <Card
                  sx={styles.rootCard}>
                  <CardActionArea>
                    <CardMedia
                      sx={styles.media}
                      image="https://artemis.arcelik.com/static/media/konsep_2.3941314b.jpg"
                      title="Yetkili Servis"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Servis Organizasyonu
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Yetkili servis çalışanlarını yönetin: ekleyin, düzenleyin ve takip edin.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              : null}
            {roleTypes.BAYI_GOREBILIR ?
              <Grid
                key={2}
                xm={12}
                component={RouterLink}
                to={`/EmployeeMain/2`}
                style={{ display: "flex", justifyContent: "center" }}
                size={{
                  xs: 12,
                  sm: 6
                }}>
                <Card sx={styles.rootCard}>
                  <CardActionArea>
                    <CardMedia
                      sx={styles.media}
                      image="https://www.sadirvanonline.com/images/galleria-umitkoy-arcelik-22.jpg"
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Bayi Organizasyonu
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Satış bayisi çalışanlarını yönetin: ekleyin, düzenleyin ve takip edin.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              : null}

            {roleTypes.BAYI_GOREBILIR === false && roleTypes.SERVIS_GOREBILIR === false ?
              <Grid
                key={2}
                xm={12}
                style={{ display: "flex", justifyContent: "center" }}
                size={{
                  xs: 12,
                  md: 8
                }}>
                <Alert severity="warning" variant="outlined" sx={{ width: '100%' }}>
                  <AlertTitle>Yetkiniz Yok</AlertTitle>
                  Sistemde Bayi ve Servis Organizasyonunu görüntüleme yetkiniz bulunmuyor.
                </Alert>
              </Grid>
              : null}
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
}

export default Employee;
